'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // Custom select box per passenger. This only transfers data to reservation
// context, it does NOT display anything by itself. The display is handled
// by normal passenger fields display, along with Winres FreeFields.

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresReservationCustomSelectController = function () {
    function WinresReservationCustomSelectController($element, $scope, productService, reservationService, localizationService) {
        _classCallCheck(this, WinresReservationCustomSelectController);

        this.$element = $element;
        this.$scope = $scope;
        this.productService = productService;
        this.reservationService = reservationService;
        this.localizationService = localizationService;
        $(this.$element).hide();
    }

    _createClass(WinresReservationCustomSelectController, [{
        key: 'getOptionKey',
        value: function getOptionKey(option) {
            return [option.Group || '', option.Destination || '', option.Product || '', option.Gender || '', option.MinPassengers || '', option.MaxPassengers || '', option.ProductComment || '', option.ProductComments ? option.ProductComments.join(',') : ''].join('-');
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // Dependencies
            // this.winresReservationContext

            // Get:
            // getContext()
            // getContext().Passengers
            // getStartDate()
            // getEndDate()

            // Set:
            // getContext().Passengers
            // setMaxPassengers()
            // setMinPassengers()
            // setMinChildren()

            // Other:
            // addCustomField()
            // removeExtraServiceFromPassenger()
            // addExtraServiceToPassenger()

            this.data = this.winresReservationContext.getContext();
            var options = {};
            var t = this;

            $(this.$element).children().each(function () {
                var child = $(this);
                var option = {
                    Group: $(child).attr('group'),
                    Gender: $(child).attr('gender'),

                    GroupVisibility: $(child).attr('group-visibility'),
                    GenderVisibility: $(child).attr('gender-visibility'),

                    CssClass: $(child).attr('css-class'),

                    MinChildren: $(child).attr('min-children'),

                    MinPassengers: $(child).attr('min-passengers'),
                    MaxPassengers: $(child).attr('max-passengers'),

                    Destination: $(child).attr('destination'),
                    Product: $(child).attr('product'),
                    ForAll: $(child).attr('for-all'),

                    ProductComment: $(child).attr('product-comment'),
                    ProductComments: _.filter(_.map(this.attributes, function (attr) {
                        return attr.name.match(/^product-comment-/) ? attr.value : null;
                    })),

                    Title: $(child).text()
                };
                options[t.getOptionKey(option)] = option;
            });
            this.options = options;
            this.allowedValues = [];
            this.updateAllowedValues();

            this.name = this.winresReservationContext.addCustomField({
                Type: 'SelectList',
                Title: this.title,
                Ask: true,
                Required: this.required == 'true',
                AllowedValues: this.allowedValues
            }, /*prepend=*/this.where == 'before');

            this.$scope.$watch(function () {
                return _this.data.Passengers;
            }, function (newValue, oldValue) {
                return _this.updatePassengers(oldValue);
            }, true);

            if (this.productGroup) {
                this.productService.getReservableProducts({
                    ReservationMode: this.reservationMode,
                    DestinationCode: this.data.DestinationCode,
                    StartDate: this.startDate ? this.startDate : this.winresReservationContext.getStartDate(),
                    EndDate: this.endDate ? this.endDate : this.winresReservationContext.getEndDate(),
                    MinCapacity: 1,
                    GroupIDs: [this.productGroup],
                    ProductType: 'common'
                }, this.localizationService.getLanguage()).then(function (products) {
                    _this.products = products;
                    _this.updateAllowedValues();
                    _this.updatePassengers();
                });
            }
        }

        // Updates the contents of the select box.

    }, {
        key: 'updateAllowedValues',
        value: function updateAllowedValues() {
            var _this2 = this;

            var allowedValues = _.filter(_.map(this.options, function (option, key) {
                var title = option.Title;
                if (option.Destination && option.Product) {
                    var productItem = _.find(_this2.products, function (p) {
                        return p.DestinationInfo.DestinationCode == option.Destination && p.DestinationInfo.ProductCode == option.Product;
                    });

                    // Product was not returned by WinresCloud - this might
                    // be due to no capacity. This gets hit also when values
                    // are updated the first time before product data has been
                    // received.
                    if (!productItem) {
                        return null;
                    }

                    // Hide options that must be selected for more than one person
                    // but only one product is left (this was the case in Bottas
                    // with the family reservation)
                    if (productItem.Capacity < parseInt(option.MinPassengers || 1)) {
                        return null;
                    }

                    if (_this2.showPrice != 'false') {
                        title += ' (' + productItem.Price + ' €)';
                    }
                }
                return { Key: key, Title: title };
            }));

            // Replace contents of allowedValues without replacing the object itself.
            // Replaceing the object might break watches / not update any places
            // where the object is referenced from directly.
            this.allowedValues.length = 0;
            this.allowedValues.push.apply(this.allowedValues, allowedValues);
        }

        // Updates
        //  - Field visibility (e.g. asking of gender, group)
        //  - Forcing of group and gender
        //  - Passenger CSS
        //  - Selection of other passengers when selecting an option that must
        //    be selected for all passengers.

    }, {
        key: 'updatePassengers',
        value: function updatePassengers(oldPassengers) {
            var _this3 = this;

            if (!this.data.Passengers) {
                return;
            }
            var forAll = null;
            var didUnsetForAll = false;

            var maxPassengers = null;
            var minPassengers = 0;
            var minChildren = 0;

            var productLinesToUpdate = [];

            _.each(this.data.Passengers, function (passenger, index) {
                var oldPassenger = oldPassengers ? oldPassengers[index] : null;
                // Find option
                var selectedOption = _this3.options[passenger[_this3.name]];
                var oldSelectedOption = oldPassenger ? _this3.options[oldPassenger[_this3.name]] : null;

                if (selectedOption != oldSelectedOption && _this3.productGroup && _this3.products) {
                    _.each(_this3.products, function (product) {
                        // Remove all old products from the passenger, which are in the
                        // group
                        _this3.winresReservationContext.removeExtraServiceFromPassenger(product, index);

                        // Add the extra service
                        // (note that removing and adding it first is better at
                        // keeping the reservation in a consistent state, since if
                        // the product is there, since it may be there multiple
                        // times in case of bug/misconfiguration)
                        if (selectedOption && product.DestinationInfo.DestinationCode == selectedOption.Destination && product.DestinationInfo.ProductCode == selectedOption.Product) {
                            var comment = '';
                            if (selectedOption.ProductComment) {
                                comment = selectedOption.ProductComment;
                            }
                            if (selectedOption.ProductComments && selectedOption.ProductComments[index]) {
                                comment = selectedOption.ProductComments[index];
                            }
                            _this3.winresReservationContext.addExtraServiceToPassenger(product, index, 1, comment);
                            productLinesToUpdate.push(_this3.winresReservationContext.findProductLineByProduct(product));
                        }
                    });
                }

                if (!passenger.FieldVisibility) {
                    passenger.FieldVisibility = {};
                }

                passenger.CssClass = {};

                var didChangeThisPassenger = !selectedOption && oldSelectedOption || selectedOption && !oldSelectedOption || selectedOption != oldSelectedOption;

                if (oldSelectedOption && oldSelectedOption.ForAll && (!selectedOption || !selectedOption.ForAll)) {
                    didUnsetForAll = true;
                }

                if (selectedOption) {
                    if (selectedOption.MinChildren && minChildren < selectedOption.MinChildren) {
                        minChildren = selectedOption.MinChildren;
                    }
                    if (selectedOption.MinPassengers > minPassengers) {
                        minPassengers = selectedOption.MinPassengers;
                    }

                    if (maxPassengers === null || selectedOption.MaxPassengers < maxPassengers) {
                        maxPassengers = selectedOption.MaxPassengers;
                    }

                    if (selectedOption.GroupVisibility) {
                        passenger.FieldVisibility['Group'] = selectedOption.GroupVisibility;
                    } else {
                        delete passenger.FieldVisibility['Group'];
                    }

                    if (selectedOption.CssClass) {
                        passenger.CssClass[selectedOption.CssClass] = true;
                    }

                    if (selectedOption.GenderVisibility) {
                        passenger.FieldVisibility['Gender'] = selectedOption.GenderVisibility;
                    } else {
                        delete passenger.FieldVisibility['Gender'];
                    }

                    if (selectedOption.Group || selectedOption.Group === '') {
                        passenger.Group = selectedOption.Group;
                    }

                    if (selectedOption.Gender) {
                        passenger.Gender = selectedOption.Gender;
                    }

                    if (selectedOption.ForAll && (!forAll || didChangeThisPassenger)) {
                        forAll = passenger[_this3.name];
                    }
                } else {
                    delete passenger.FieldVisibility['Gender'];
                    delete passenger.FieldVisibility['Group'];
                }
            });

            _.each(_.uniq(productLinesToUpdate), function (line) {
                _this3.reservationService.calculateProductLinePrice(_this3.data, line, _this3.localizationService.getLanguage()).then(function (result) {
                    line.TotalPrice = result.Price;
                    line.UnitPrice = result.UnitPrice;
                });
            });

            this.winresReservationContext.setMaxPassengers(maxPassengers);
            this.winresReservationContext.setMinPassengers(minPassengers);
            this.winresReservationContext.setMinChildren(minChildren);

            _.each(this.data.Passengers, function (passenger, index) {
                if (!passenger.FieldVisibility) {
                    // Even if this has been added to each passenger in the previous
                    // loop, there might be new passengers after setMinPassengers.
                    passenger.FieldVisibility = {};
                }
                if (didUnsetForAll) {
                    // If you remove a set-all option from one passenger (the first
                    // one) it will be removed from all. Otherwise, it would be
                    // impossible to deselect a set-all option.
                    passenger[_this3.name] = null;
                    delete passenger.FieldVisibility[_this3.name];
                } else if (forAll) {
                    // Note that the other effects for changing the select are
                    // handled because this triggers the $watch again.
                    passenger[_this3.name] = forAll;
                    if (index == 0) {
                        delete passenger.FieldVisibility[_this3.name];
                    } else {
                        passenger.FieldVisibility[_this3.name] = 'readonly';
                    }
                }
            });
        }
    }]);

    return WinresReservationCustomSelectController;
}();

WinresReservationCustomSelectController.$inject = ['$element', '$scope', 'productService', 'reservationService', 'localizationService'];

_module3.default.component('winresReservationCustomSelect', {
    template: '',
    controller: WinresReservationCustomSelectController,
    require: {
        winresReservationContext: '^^winresReservationContext'
    },
    bindings: {
        productGroup: '@', // Default empty (no products will be selected.)
        // Otherwise, number of the group product linking group.
        // 0 means avaintuote or linking group 0.

        startDate: '@', // For products. If not set, start date of reservation context will be used.
        endDate: '@', // For products. If not set, start date of reservation context wil be used.

        title: '@', // Required
        required: '@', // TRue/false Default false
        where: '@', // 'after' or 'before' Default after

        showPrice: '@' // true/false default true (if there are products)
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationCustomSelect/winresReservationCustomSelect.js
// module id = 368
// module chunks = 2